import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { LockIcon } from '@estee/elc-icons';
import { FormWarning } from '@estee/elc-form';
import { Colors } from '@estee/elc-base-theme';

interface ISamplesWarningMessageProps {
  message: string;
  noStyle?: boolean;
}

const WarningMessageContainer = styled(FormWarning)`
  text-align: left;
  border: none;
  margin-bottom: 10px;
`;

const WarningContent = styled.div`
  display: flex;
  gap: 10px;
`;

const WarningMessageText = styled.span<{ noStyle: boolean }>`
  display: flex;
  align-items: flex-end;
  color: ${prop => (prop.noStyle ? Colors.black : Colors.warning)};
`;

const StyledLockIcon = styled(LockIcon)``;

@observer
class WarningMessage extends React.Component<ISamplesWarningMessageProps> {
  render(): JSX.Element {
    const {
      message,
      noStyle,
    } = this.props;

    return (
      <WarningMessageContainer className="elc-notification-message">
        <WarningContent>
          {!noStyle && <StyledLockIcon className="lock-icon" />}
          <WarningMessageText noStyle={noStyle}>
            {message}
          </WarningMessageText>
        </WarningContent>
      </WarningMessageContainer>
    );
  }
}

export default WarningMessage;
